/// <amd-module name="Test/TestPlansHubRefresh/TestPlanClonePanel/Redux/TestPlanClonePanelModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestPlanClonePanelSaga } from "./TestPlanClonePanelSaga";
import { TestPlanClonePanelActions } from "./TestPlanClonePanelActions";
import { TestPlanClonePanelReducer } from "./TestPlanClonePanelReducer";
import { ITestPlanClonePanelAwareState } from "./TestPlanClonePanelContracts";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";

export const TestPlanClonePanelModule: ISagaModule<ITestPlanClonePanelAwareState> = {
    id: "testplan-clone-panel",
    reducerMap: {
        testPlanClonePanelState: TestPlanClonePanelReducer,
        testHubRefreshState: TestHubRefreshReducer
    },
    initialActions: [TestPlanClonePanelActions.getRootNodes(), TestPlanClonePanelActions.loadModules()],
    sagas: [TestPlanClonePanelSaga]
};
